import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function TypeFormatter({ info }) {
  const { value } = getInfo(info)
  return <>{TEMPLATES[value]}</>
}

export const TEMPLATES = {
  password_reset: 'Password Reset',
  sweep_subscription_confirmation: 'Sweep Subscription Confirmation',
  consumer_delete_report: 'Consumer Delete Report',
  sweep_new_winner: 'Sweep New Winner Alert',
}
